export const TEAMSPACE_QUERY_KEYS = {
  space: (id: string) => ['space', id],
  spaceCredits: (id: string) => ['spaceCredits', id],
  spaces: ['spaces'],
} as const;
